import { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import './Offers.css';
import Offer from './offer/Offer';

export default function Offers() {
	const [posts, setPosts] = useState([]);

	useEffect(() => {
		const fetchPosts = async () => {
			const data = await apiFetch({
				path: `/dawn-ranch/offers`,
			});
			setPosts(data);
		};

		fetchPosts();
	}, []);

	return (
		<section className='offers-module'>
			{posts && posts.length > 0 ? (
				<div className='offers-list'>
					{posts.map((post) => (
						<Offer key={post.id} offer={post} />
					))}
				</div>
			) : (
				<div className=''>NO EVENTS</div>
			)}
		</section>
	);
}
